<style scoped lang="scss">
.quillWrapper {
  background: #fff;
}

:deep(.ql-editor) {
  min-height: 0 !important;
  height: 100px !important;
}

.btn-outline-primary {
  border: 1px solid #ced4da;
  background: #ced4da;
}
</style>

<template>
  <b-form-group
    className="my-4 d-flex align-items-center"
    label-cols="4"
    label-cols-lg="2"
    label-size="Default"
    :label="label"
    label-for="input-default"
    label-align="right"
    label-class="p-0 mr-3"
  >
    <VueEditor v-if="visible" :id="localValue" v-model="localValue" :editor-options="editorOptions" />
    <b-input-group v-else>
      <b-form-input :id="localValue" :name="localValue" v-model="localValue" />
      <b-input-group-append>
        <b-button variant="outline-primary" @click="toggle">
          <img src="@/assets/images/editor-icon.svg" style="width: 1.2rem" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: "TextEditor",
  data() {
    return {
      visible: false,
    };
  },
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.stripQuillArtifacts(val));
      },
    },
    editorOptions() {
      const vm = this;
      return {
        modules: {
          toolbar: {
            container: [
              ["back", "bold", "italic", "underline", "strike"],
              [{ color: [] }, { background: [] }],
            ],
            handlers: {
              back() {
                vm.visible = false;
              },
            },
          },
        },
      };
    },
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    injectBackIcon() {
      const btn = this.$el.querySelector(".ql-toolbar .ql-back");
      if (!btn) return;
      btn.innerHTML = `
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
           stroke="#444" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>`;
    },
    stripQuillArtifacts(html) {
      const el = document.createElement("div");
      el.innerHTML = html;
      el.querySelectorAll(["span.ql-cursor", ".ql-tooltip", ".ql-clipboard", ".ql-composition"].join(",")).forEach(
        (n) => n.remove()
      );
      el.innerHTML = el.innerHTML.replace(/[\u200B-\u200D\uFEFF]/g, "");
      return el.innerHTML;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => this.injectBackIcon());
      }
    },
  },
};
</script>
